module.exports = __webpack_public_path__ + "static/img/cockpit.b2b264f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpit/cockpit.png
// module id = QP58
// module chunks = 31